<template>
  <div class="main-views-container">
    <div :class="{'main-view2':isMobile,'main-view1':!isMobile}">
      <div v-if="useDefaultTitle" class="main-title">
        <h1 :style="{wordBreak:'break-all'}">{{title}}</h1>
      </div>
      <el-divider v-if="useDefaultTitle">{{$store.getters.windowData.height}}</el-divider>
      <div id="data"></div>
      <preview-img />
    </div>
    <el-backtop target=".main-views-container"></el-backtop>
  </div>
</template>

<script>
import { pageApi } from '@/api/index';
import previewImg from "@/components/PreviewImg";
import PhotoSwipe from 'photoswipe/dist/photoswipe'
import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default'

export default {
  components: {
    previewImg
  },
  data () {
    return {
      flag: false,
      show: false,
      index: 0,
      startPosition: 0,
      images: [],
      data: '',
      title: '',
      isMobile: false,
      img: '',
      imgList: [],
      useDefaultTitle: true
    }
  },
  mounted () {
    // 判断是否是移动端
    this.isMobile = /Android|webOS|iPhone|iPad|BlackBerry/i.test(navigator.userAgent)
    this.$emit('header', 'no');
    this.getDetail();
  },
  watch: {
    isMobile (val) {
      location.replace(location.href)
    }
  },
  methods: {
    onScale() {
      this.flag = !this.flag;
      const el = document.querySelector('.van-image-preview__image');
      if(this.flag) {
        el.childNodes[0].setAttribute('class', 'scale-img-preview-bigger')
      } else {
        el.childNodes[0].setAttribute('class', 'scale-img-preview-smaller')
      }
      

    },
    openPhotoPreview(src, srcItems) {
      var pswpElement = document.querySelectorAll('.pswp')[0];
      var items = srcItems;
      const index = srcItems.indexOf(src)
      var options = {
          index: index
      };
      var gallery = new PhotoSwipe( pswpElement, PhotoSwipeUI_Default, items, options);
      gallery.init();
    },
    // 获取
    async getDetail () {
      let param = {
        id: this.$route.query.id
      };
      let _res = await pageApi.getStaticpageById(param);
      this.data = _res.list.content;
      this.title = _res.list.title;
      this.useDefaultTitle = _res.list.useDefaultTitle
      document.title = this.title;
      let heads = document.getElementsByTagName('head')[0];
      let link = heads.querySelectorAll('link');
      link.forEach((dom) => {
        if (dom.rel == 'icon' && _res.list.iconUrl) {
          dom.type = "image/x-icon";
          dom.href = _res.list.iconUrl;
        }
      })
      this.getCss();
    },
    // 给富文本添加样式
    getCss () {
      let _tempDom = document.createElement('div');
      _tempDom.innerHTML = this.data;
      // 引用样式
      let blockquoteAll = _tempDom.querySelectorAll('blockquote');
      blockquoteAll.forEach((dom) => {
        dom.style.display = 'block';
        dom.style.borderLeft = '8px solid #d0e5f2';
        dom.style.padding = '5px 10px';
        dom.style.margin = '10px 0';
        dom.style.lineHeight = '1.4';
        // dom.style.fontSize = '100%';
        dom.style.backgroundColor = '#f1f1f1';

      });
      // 链接样式
      // let aAll = _tempDom.querySelectorAll('a');
      // aAll.forEach((dom)=>{
      //     dom.style.color = '#096DD9';
      // })
      // 图片样式
      let imgAll = _tempDom.querySelectorAll('img');
      imgAll.forEach((dom) => {
        dom.style.margin = '0';
      })
      // 表格样式
      let tableAll = _tempDom.querySelectorAll('table');
      tableAll.forEach((dom) => {
        // 表格默认盒子div 设置溢出时滚动条
        dom.parentNode.style.overflow = 'auto'
        dom.style.width = '100%';
        dom.style.borderTop = '1px solid #ccc';
        dom.style.borderLeft = '1px solid #ccc';
        dom.style.marginBottom = '1em';
        dom.style.overflow = 'auto'
        dom.style.wordBreak = 'break-all';
      });
      let tdAll = _tempDom.querySelectorAll('td');
      let thAll = _tempDom.querySelectorAll('th');
      tdAll.forEach((dom) => {
        dom.style.borderBottom = '1px solid #ccc';
        dom.style.borderRight = '1px solid #ccc';
        dom.style.padding = '3px 5px';
      });
      thAll.forEach((dom) => {
        dom.style.borderBottom = '2px solid #ccc';
        dom.style.borderRight = '1px solid #ccc';
        dom.style.padding = '3px 5px';
        dom.style.textAlign = 'center';
        dom.style.backgroundColor = '#f1f1f1';
      });
      // 代码样式
      let codeAll = _tempDom.querySelectorAll('code');
      codeAll.forEach((dom) => {
        dom.style.display = 'block';
        dom.style.borderRadius = '3px';
        dom.style.padding = '3px 5px';
        dom.style.margin = '10px 3px';
        dom.style.backgroundColor = '#f1f1f1';
        dom.style.Zoom = '1';
      });
      // 代办事项样式
      let spanAll = _tempDom.querySelectorAll('span');
      spanAll.forEach((dom) => {
        if (dom.contentEditable == 'false') {
          dom.style.position = 'relative';
          dom.style.left = '-8px';
          dom.style.top = '2px';
        }
      })
      // 列表样式
      let olAll = _tempDom.querySelectorAll('ol');
      olAll.forEach((dom) => {
        dom.style.margin = '10px 0 10px 20px';
        dom.style.padding = '0';
      });
      let ulAll = _tempDom.querySelectorAll('ul');
      ulAll.forEach((dom) => {
        if (dom.className == 'w-e-todo') {
          let li = dom.querySelectorAll('li')
          li.forEach((li) => {
            li.style.listStyle = 'none';
            li.style.fontSize = '1em';
          })
          dom.style.margin = '0 0 0 8px';
        } else {
          dom.style.margin = '10px 0 10px 20px';
        }
        dom.style.padding = '0';
      });
      // pre标签
      let preAll = _tempDom.querySelectorAll('pre');
      preAll.forEach((dom) => {
        dom.style.overflow = 'auto'
      })
      // p标签
      let pAll = _tempDom.querySelectorAll('p');
      pAll.forEach((dom) => {
        dom.style.wordBreak = 'break-all';
      })
      // h1-h6标签
      for (let i = 1; i <= 6; i++) {
        let hAll = _tempDom.querySelectorAll(`h${i}`);
        hAll.forEach((dom) => {
          dom.style.wordBreak = 'break-all';
        })
      }
      this.data = _tempDom.innerHTML;
      document.getElementById('data').innerHTML = this.data;


      // 图片事件
      let imgAll2 = document.querySelectorAll('img');
      let that = this;
      let srcList = []
      for (let i = 0; i < imgAll2.length; i++) {
        srcList.push(imgAll2[i].getAttribute('src'))
      }
      function loadImage(url) {
        return new  Promise(resolve => {
            const image = new Image();
            image.addEventListener('load', () => {
                resolve({
                  src: `${url}?imageMogr2/format/webp`,
                  w: image.naturalWidth,
                  h: image.naturalHeight
                });
            });
            image.src = url; 
        });
}
       Promise.all(srcList.map(src=> loadImage(src))).then(arr=> {
         console.log(arr);
         this.imgList = arr;
      });
      for (let i = 0; i < imgAll2.length; i++) {
        imgAll2[i].addEventListener('click', function () {
          that.img = this.getAttribute('src')
          const index = srcList.indexOf(that.img);
          var pswpElement = document.querySelectorAll('.pswp')[0];
          var options = {
              index: index
          };
          var gallery = new PhotoSwipe( pswpElement, PhotoSwipeUI_Default, that.imgList, options);
          gallery.init();
        })
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.main-views-container {
  .el-icon-zoom-in:before {
    color: white;
    font-size: 22px;
    position: absolute;
    top: 16px;
    left: 300px;
  }
  .scale-img-preview-bigger {
    transition-duration: 0.3s;
    transform: scale(2, 2) translate(0px, 0px);
  }
  .scale-img-preview-smaller {
    transition-duration: 0.3s;
    transform: scale(0, 0) translate(0px, 0px);
  }
  overflow: auto;
  height: 100%;
  .main-view1 {
    padding: 10px 20px;
    margin: 0px auto;
    max-width: 800px;
    min-height: 100%;
    .main-title {
      font-size: 24px;
    }
    background-color: #fff;
  }
  .main-view2 {
    padding: 10px 20px;
    margin: 0px auto;
    width: 100%;
    min-height: 100%;
    background-color: #fff;
    .main-title {
      font-size: 24px;
    }
  }
}
</style>
